import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import { Button, Col, FormGroup, OverlayTrigger, Radio, Row, Tooltip } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { connect } from "react-redux"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import * as ItemTypes from "../../../redux/items/types"
import {
  filterGLAccountsByType,
  glAccountsDataWithFineractId,
  GLAccountType,
  sortGLAccounts,
  validateTextState,
  VALIDATION_TYPE
} from "../../../lib/utils"
import { browserHistory } from "react-router"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import CloseableProcessesStatus from "../../fragments/CloseableProcessesStatus"

const ACCOUNTING_RULE_TYPE = {
  NONE: 'NONE',
  CASH_BASED: 'CASH_BASED',
  ACCRUAL_PERIODIC: 'ACCRUAL_PERIODIC',
  ACCRUAL_UPFRONT: 'ACCRUAL_UPFRONT'
},

textHelp = 'Learn more about loan integration with accounting',

mifosLink = 'https://mifosforge.jira.com/wiki/spaces/MIFOSX/pages/31850515/Loan+Integration+With+Accounting'

class LoanAccountingForm extends React.Component {

  state = {

    accountingRuleType: ACCOUNTING_RULE_TYPE.NONE,
    fundSourceAccountId: '',
    transfersInSuspenseAccountId: '',
    loanPortfolioAccountId: '',

    interestOnLoanAccountId: '',
    incomeFromFeeAccountId: '',
    incomeFromRecoveryAccountId: '',
    incomeFromPenaltyAccountId: '',

    writeOffAccountId: '',
    overpaymentLiabilityAccountId: '',

    receivableInterestAccountId: '',
    receivablePenaltyAccountId: '',
    receivableFeeAccountId: '',

    accountingRuleTypeValidationState: VALIDATION_TYPE.SUCCESS,
    fundSourceAccountIdValidationState: VALIDATION_TYPE.NULL,
    transfersInSuspenseAccountIdValidationState: VALIDATION_TYPE.NULL,
    loanPortfolioAccountIdValidationState: VALIDATION_TYPE.NULL,
    interestOnLoanAccountIdValidationState: VALIDATION_TYPE.NULL,
    incomeFromFeeAccountIdValidationState: VALIDATION_TYPE.NULL,
    incomeFromRecoveryAccountIdValidationState: VALIDATION_TYPE.NULL,
    incomeFromPenaltyAccountIdValidationState: VALIDATION_TYPE.NULL,
    writeOffAccountIdValidationState: VALIDATION_TYPE.NULL,
    overpaymentLiabilityAccountIdValidationState: VALIDATION_TYPE.NULL,
    receivableInterestAccountIdValidationState: VALIDATION_TYPE.NULL,
    receivablePenaltyAccountIdValidationState: VALIDATION_TYPE.NULL,
    receivableFeeAccountIdValidationState: VALIDATION_TYPE.NULL,

    running: false,
    success: false,
    error: null,
    closeStatuses: false,
    isUpdate: this.props.isUpdate,
  }

  componentDidMount() {
    this.props.loadData()
    this.loadLoanAccountingRule()
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutId)
  }

  loadLoanAccountingRule = () => {

    this.setState({
      running: true,
      error: null,
      closeStatuses: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.getLoanAccountingRule(accessToken),
      data => this.dataLoaded(data),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  dataLoaded = data => {

    if (!data) return

    const { 
      accountingRuleType, fundSourceAccountId, transfersInSuspenseAccountId,
      loanPortfolioAccountId, interestOnLoanAccountId, incomeFromFeeAccountId,
      incomeFromRecoveryAccountId, incomeFromPenaltyAccountId, writeOffAccountId,
      overpaymentLiabilityAccountId, receivableInterestAccountId, receivablePenaltyAccountId,
      receivableFeeAccountId } = data

    this.setState({
      accountingRuleType, fundSourceAccountId, transfersInSuspenseAccountId,
      loanPortfolioAccountId, interestOnLoanAccountId, incomeFromFeeAccountId,
      incomeFromRecoveryAccountId, incomeFromPenaltyAccountId, writeOffAccountId,
      overpaymentLiabilityAccountId, receivableInterestAccountId, receivablePenaltyAccountId,
      receivableFeeAccountId
    })
  }

  fundSourceAccountIdChanged = fundSourceAccountId => this.setState({
    fundSourceAccountId,
    fundSourceAccountIdValidationState: validateTextState(fundSourceAccountId, false),
    error: null,
  })

  transfersInSuspenseAccountIdChanged = transfersInSuspenseAccountId => this.setState({
    transfersInSuspenseAccountId,
    transfersInSuspenseAccountIdValidationState: validateTextState(transfersInSuspenseAccountId, false),
    error: null,
  })

  loanPortfolioAccountIdChanged = loanPortfolioAccountId => this.setState({
    loanPortfolioAccountId,
    loanPortfolioAccountIdValidationState: validateTextState(loanPortfolioAccountId, false),
    error: null,
  })

  interestOnLoanAccountIdChanged = interestOnLoanAccountId => this.setState({
    interestOnLoanAccountId,
    interestOnLoanAccountIdValidationState: validateTextState(interestOnLoanAccountId, false),
    error: null,
  })

  incomeFromFeeAccountIdChanged = incomeFromFeeAccountId => this.setState({
    incomeFromFeeAccountId,
    incomeFromFeeAccountIdValidationState: validateTextState(incomeFromFeeAccountId, false),
    error: null,
  })

  incomeFromRecoveryAccountIdChanged = incomeFromRecoveryAccountId => this.setState({
    incomeFromRecoveryAccountId,
    incomeFromRecoveryAccountIdValidationState: validateTextState(incomeFromRecoveryAccountId, false),
    error: null,
  })

  incomeFromPenaltyAccountIdChanged = incomeFromPenaltyAccountId => this.setState({
    incomeFromPenaltyAccountId,
    incomeFromPenaltyAccountIdValidationState: validateTextState(incomeFromPenaltyAccountId, false),
    error: null,
  })

  writeOffAccountIdChanged = writeOffAccountId => this.setState({
    writeOffAccountId,
    writeOffAccountIdValidationState: validateTextState(writeOffAccountId, false),
    error: null,
  })

  overpaymentLiabilityAccountIdChanged = overpaymentLiabilityAccountId => this.setState({
    overpaymentLiabilityAccountId,
    overpaymentLiabilityAccountIdValidationState: validateTextState(overpaymentLiabilityAccountId, false),
    error: null,
  })

  receivableInterestAccountIdChanged = receivableInterestAccountId => this.setState({
    receivableInterestAccountId,
    receivableInterestAccountIdValidationState: validateTextState(receivableInterestAccountId, false),
    error: null,
  })

  receivablePenaltyAccountIdChanged = receivablePenaltyAccountId => this.setState({
    receivablePenaltyAccountId,
    receivablePenaltyAccountIdValidationState: validateTextState(receivablePenaltyAccountId, false),
    error: null,
  })

  receivableFeeAccountIdChanged = receivableFeeAccountId => this.setState({
    receivableFeeAccountId,
    receivableFeeAccountIdValidationState: validateTextState(receivableFeeAccountId, false),
    error: null,
  })

  accountingRuleTypeChanged = accountingRuleType => this.setState({
    accountingRuleType,
    accountingRuleTypeValidationState: VALIDATION_TYPE.SUCCESS,
    error: null,
  })

  areAllValid = values => values.every(item => item === VALIDATION_TYPE.SUCCESS)

  isDataValid = () => {

    const { accountingRuleType, fundSourceAccountId, transfersInSuspenseAccountId,
      loanPortfolioAccountId, interestOnLoanAccountId, incomeFromFeeAccountId,
      incomeFromRecoveryAccountId, incomeFromPenaltyAccountId, writeOffAccountId,
      overpaymentLiabilityAccountId, receivableInterestAccountId, receivablePenaltyAccountId,
      receivableFeeAccountId } = this.state,

    accountingRuleTypeState = validateTextState(accountingRuleType, false),
    fundSourceAccountIdState = validateTextState(fundSourceAccountId, false),
    transfersInSuspenseAccountIdState = validateTextState(transfersInSuspenseAccountId, false),
    loanPortfolioAccountIdState = validateTextState(loanPortfolioAccountId, false),
    interestOnLoanAccountIdState = validateTextState(interestOnLoanAccountId, false),
    incomeFromFeeAccountIdState = validateTextState(incomeFromFeeAccountId, false),
    incomeFromRecoveryAccountIdState = validateTextState(incomeFromRecoveryAccountId, false),
    incomeFromPenaltyAccountIdState = validateTextState(incomeFromPenaltyAccountId, false),
    writeOffAccountIdState = validateTextState(writeOffAccountId, false),
    overpaymentLiabilityAccountIdState = validateTextState(overpaymentLiabilityAccountId, false),
    receivableInterestAccountIdState = validateTextState(receivableInterestAccountId, false),
    receivablePenaltyAccountIdState = validateTextState(receivablePenaltyAccountId, false),
    receivableFeeAccountIdState = validateTextState(receivableFeeAccountId, false),

    isNone = accountingRuleType === ACCOUNTING_RULE_TYPE.NONE,

    extraFields = accountingRuleType === ACCOUNTING_RULE_TYPE.ACCRUAL_PERIODIC ||
    accountingRuleType === ACCOUNTING_RULE_TYPE.ACCRUAL_UPFRONT

    this.setState({ accountingRuleTypeValidationState: accountingRuleTypeState })

    if (!isNone) {
      this.setState({
        fundSourceAccountIdValidationState: fundSourceAccountIdState,
        transfersInSuspenseAccountIdValidationState: transfersInSuspenseAccountIdState,
        loanPortfolioAccountIdValidationState: loanPortfolioAccountIdState,
        interestOnLoanAccountIdValidationState: interestOnLoanAccountIdState,
        incomeFromFeeAccountIdValidationState: incomeFromFeeAccountIdState,
        incomeFromRecoveryAccountIdValidationState: incomeFromRecoveryAccountIdState,
        incomeFromPenaltyAccountIdValidationState: incomeFromPenaltyAccountIdState,
        writeOffAccountIdValidationState: writeOffAccountIdState,
        overpaymentLiabilityAccountIdValidationState: overpaymentLiabilityAccountIdState
      })
    }

    if (extraFields) {
      this.setState({
        receivableInterestAccountIdValidationState: receivableInterestAccountIdState,
        receivablePenaltyAccountIdValidationState: receivablePenaltyAccountIdState,
        receivableFeeAccountIdValidationState: receivableFeeAccountIdState
      })
    }

    const firstPart = this.areAllValid([accountingRuleTypeState]),

    secondPart = isNone || this.areAllValid([fundSourceAccountIdState,
      transfersInSuspenseAccountIdState, loanPortfolioAccountIdState, interestOnLoanAccountIdState,
      incomeFromFeeAccountIdState, incomeFromRecoveryAccountIdState, incomeFromPenaltyAccountIdState,
      writeOffAccountIdState, overpaymentLiabilityAccountIdState ]),

    thirdPart = !extraFields || this.areAllValid([receivableInterestAccountIdState,
      receivablePenaltyAccountIdState, receivableFeeAccountIdState])

    return firstPart && secondPart && thirdPart
  }

  saveClicked = () => {

    this.setState({ closeStatuses: false })

    if (!this.isDataValid()) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    const { accountingRuleType, fundSourceAccountId, transfersInSuspenseAccountId,
      loanPortfolioAccountId, interestOnLoanAccountId, incomeFromFeeAccountId,
      incomeFromRecoveryAccountId, incomeFromPenaltyAccountId, writeOffAccountId,
      overpaymentLiabilityAccountId, receivableInterestAccountId, receivablePenaltyAccountId,
      receivableFeeAccountId } = this.state,

    data = { accountingRuleType, fundSourceAccountId, transfersInSuspenseAccountId,
      loanPortfolioAccountId, interestOnLoanAccountId, incomeFromFeeAccountId,
      incomeFromRecoveryAccountId, incomeFromPenaltyAccountId, writeOffAccountId,
      overpaymentLiabilityAccountId, receivableInterestAccountId, receivablePenaltyAccountId,
      receivableFeeAccountId }

    this.setState({
      running: true,
      error: null,
      success: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.saveLoanAccountingRule(accessToken, data),
      _ => {
        this.setState({ success: true })
        this.timeOutId = setTimeout(() => this.setState({ success: false }), 3000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderRadioItem = (text, ruleType) => {

    const { accountingRuleType, isUpdate } = this.state

    return <Radio disabled={ !isUpdate } name="type" inline
      checked={ accountingRuleType === ruleType }
      onChange={() => this.accountingRuleTypeChanged(ruleType)}
      className="mr-15">
      { text }
    </Radio>
  }

  renderAccountingType = () => {

    const { accountingRuleTypeValidationState } = this.state
    return (
      <FormGroup controlId='accountingRuleType' validationState={ accountingRuleTypeValidationState }>
        { this.renderRadioItem('None', ACCOUNTING_RULE_TYPE.NONE) }

        { this.renderRadioItem('Cash', ACCOUNTING_RULE_TYPE.CASH_BASED) }

        { this.renderRadioItem('Accrual (periodic)', ACCOUNTING_RULE_TYPE.ACCRUAL_PERIODIC) }

        { this.renderRadioItem('Accrual (upfront)', ACCOUNTING_RULE_TYPE.ACCRUAL_UPFRONT) }
      </FormGroup>
    )
  }

  getLabel = (text, tooltip) => (
    <span>
      { text }&nbsp;
      <OverlayTrigger placement="top" overlay={ <Tooltip id="helpTextAccount">{ tooltip }</Tooltip> }>
        <FontAwesome name='question-circle' className="green" />
      </OverlayTrigger>
    </span>
  )

  renderAssets = glAccounts => {

    const { accountingRuleType, isUpdate, fundSourceAccountId, loanPortfolioAccountId,
      transfersInSuspenseAccountId, receivableInterestAccountId, receivableFeeAccountId,
      receivablePenaltyAccountId, fundSourceAccountIdValidationState, loanPortfolioAccountIdValidationState,
      transfersInSuspenseAccountIdValidationState, receivableInterestAccountIdValidationState,
      receivableFeeAccountIdValidationState, receivablePenaltyAccountIdValidationState } = this.state,

    tooltipFundSource = `an Asset account (typically Bank or cash) that is 
    debited during repayments/payments an credited using disbursals.`,

    tooltipLoanPortfolio = `an Asset account that is debited during disbursement 
    and credited during principal repayment/writeoff.`,

    tooltipTransferInsuspense = `an Asset account that is used a suspense account for 
    tracking portfolios of loans under transfer.`,

    tooltipInterestReceivable = `an Asset account that is used to accrue interest`,

    tooltipFeesReceivable = `an Asset account that is used to accrue fees`,

    tooltipPenaltiesReceivable = `an Asset account that is used to accrue penalties`,

    showExtraFields = accountingRuleType === ACCOUNTING_RULE_TYPE.ACCRUAL_PERIODIC ||
    accountingRuleType === ACCOUNTING_RULE_TYPE.ACCRUAL_UPFRONT

    return (
      <div>
        <h4>Assets</h4>
        <Row>
          <Col md={6}>

            <FormControlInlineSelect
              controlId='fundSource' validationState={ fundSourceAccountIdValidationState }
              label={ this.getLabel('Fund source', tooltipFundSource) }
              value={ fundSourceAccountId }
              onChange={ this.fundSourceAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
          <Col md={6}>

            <FormControlInlineSelect
              controlId='loanPortfolioAccountId' validationState={ loanPortfolioAccountIdValidationState }
              label={ this.getLabel('Loan portfolio', tooltipLoanPortfolio) }
              value={ loanPortfolioAccountId }
              onChange={ this.loanPortfolioAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
        </Row>

        <Row className="mt-20">
          <Col md={6}>

            <FormControlInlineSelect
              controlId='transfersInSuspense' validationState={ transfersInSuspenseAccountIdValidationState }
              label={ this.getLabel('Transfer in suspense', tooltipTransferInsuspense) }
              value={ transfersInSuspenseAccountId }
              onChange={ this.transfersInSuspenseAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
          <Col md={6}>

            { showExtraFields &&
            <FormControlInlineSelect
              controlId='receivableFeeAccountId' validationState={ receivableFeeAccountIdValidationState }
              label={ this.getLabel('Fees Receivable', tooltipFeesReceivable) }
              value={ receivableFeeAccountId }
              onChange={ this.receivableFeeAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />}
          </Col>
        </Row>

        <Row className="mt-20">
          <Col md={6}>

            { showExtraFields &&
            <FormControlInlineSelect
              controlId='receivableInterestAccountId' validationState={ receivableInterestAccountIdValidationState }
              label={ this.getLabel('Interest Receivable', tooltipInterestReceivable) }
              value={ receivableInterestAccountId }
              onChange={ this.receivableInterestAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />}
          </Col>
          <Col md={6}>

            { showExtraFields &&
            <FormControlInlineSelect
              controlId='receivablePenaltyAccountId' validationState={ receivablePenaltyAccountIdValidationState }
              label={ this.getLabel('Penalties Receivable', tooltipPenaltiesReceivable) } 
              value={ receivablePenaltyAccountId }
              onChange={ this.receivablePenaltyAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />}
          </Col>
        </Row>
      </div>
    )
  }

  renderIncome = glAccounts => {

    const { isUpdate, interestOnLoanAccountId, incomeFromFeeAccountId,
      incomeFromRecoveryAccountId, incomeFromPenaltyAccountId, interestOnLoanAccountIdValidationState,
      incomeFromFeeAccountIdValidationState, incomeFromRecoveryAccountIdValidationState,
      incomeFromPenaltyAccountIdValidationState } = this.state,

    tooltipIncomefromInterest = `an Income account that is credited during interest payment.`,

    tooltipIncomeFromFees = `An Income account which is credited when a fee is paid by account
    holder on this account`,

    tooltipIncomeFromPenalties = `An Income account, which is credited when a penalty is paid by
    account holder on this account`,

    tooltipIncomeFromRecoveryRepayments = `an Income account that is credited during Recovery Repayment.`

    return (
      <div>
        <h4>Income</h4>
        <Row>
          <Col md={6}>

            <FormControlInlineSelect
              controlId='interestOnLoanAccountId' validationState={ interestOnLoanAccountIdValidationState }
              label={ this.getLabel('Income from Interest', tooltipIncomefromInterest) } 
              value={ interestOnLoanAccountId }
              onChange={ this.interestOnLoanAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>

          <Col md={6}>
            <FormControlInlineSelect
              controlId='incomeFromRecoveryAccountId' validationState={ incomeFromRecoveryAccountIdValidationState }
              label={ this.getLabel('Income from Recovery Repayments', tooltipIncomeFromRecoveryRepayments) } 
              value={ incomeFromRecoveryAccountId }
              onChange={ this.incomeFromRecoveryAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
        </Row>

        <Row className="mt-10">
          <Col md={6}>
            <FormControlInlineSelect
              controlId='incomeFromFeeAccountId' validationState={ incomeFromFeeAccountIdValidationState }
              label={ this.getLabel('Income from fees', tooltipIncomeFromFees) } 
              value={ incomeFromFeeAccountId }
              onChange={ this.incomeFromFeeAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>

          <Col md={6}>
            <FormControlInlineSelect
              controlId='incomeFromPenaltyAccountId' validationState={ incomeFromPenaltyAccountIdValidationState }
              label={ this.getLabel('Income from penalties', tooltipIncomeFromPenalties) } 
              value={ incomeFromPenaltyAccountId }
              onChange={ this.incomeFromPenaltyAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
        </Row>
      </div>
    )
  }

  renderExpenses = glAccounts => {

    const { isUpdate, writeOffAccountId, writeOffAccountIdValidationState } = this.state,

    tooltipLossesWrittenOff = `An expense account that is debited on principal writeoff 
    (also debited in the events of interest, fee and penalty written-off in case of accrual based accounting.)`

    return (
      <div>
        <h4>Expenses</h4>
        <Row>
          <Col md={6}>

            <FormControlInlineSelect
              controlId='writeOffAccountId' validationState={ writeOffAccountIdValidationState }
              label={ this.getLabel('Losses written off', tooltipLossesWrittenOff) } 
              value={ writeOffAccountId }
              onChange={ this.writeOffAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
        </Row>
      </div>
    )
  }

  renderLiabilities = glAccounts => {

    const { isUpdate, overpaymentLiabilityAccountId, overpaymentLiabilityAccountIdValidationState } = this.state,

    tooltipOverPaymentLiability = `an Liability account that is credited on overpayments 
    and credited when refunds are made to client.`

    return (
      <div>
        <h4>Liabilities</h4>
        <Row>
          <Col md={6}>

            <FormControlInlineSelect
              controlId='overpaymentLiabilityAccountId' validationState={ overpaymentLiabilityAccountIdValidationState }
              label={ this.getLabel('Over payment liability', tooltipOverPaymentLiability) } 
              value={ overpaymentLiabilityAccountId }
              onChange={ this.overpaymentLiabilityAccountIdChanged }
              options={ glAccounts }
              withEmptyOption={ true }
              disabled={ !isUpdate }
            />
          </Col>
        </Row>
      </div>
    )
  }

  renderButtons = () => {

    const { running } = this.state
    return (
      <div className="align-right mt-30">
        <Button onClick={() => browserHistory.push('/loanaccounting')} className="w-100"
          disabled={ running }>
          <FontAwesome name='close' /> Cancel
        </Button>

        <Button bsStyle="success" onClick={ this.saveClicked } className="w-120 ml-10" 
          disabled={ running }>
          <FontAwesome name='save' /> Save
        </Button>
      </div>
    )
  }

  getTooltipHelp = () => (
    <OverlayTrigger placement="top" overlay={ <Tooltip id="helpText">{ textHelp }</Tooltip> }>
      <FontAwesome name='info-circle' className="blue" />
    </OverlayTrigger>
  )

  renderSections = () => {

    const { accountingRuleType } = this.state

    if (accountingRuleType === ACCOUNTING_RULE_TYPE.NONE) return null

    const { glAccounts } = this.props,

    glAccountsData = glAccountsDataWithFineractId(glAccounts),

    assets = glAccountsData.filter(item => filterGLAccountsByType(item, GLAccountType.ASSET)),

    incomes = glAccountsData.filter(item => filterGLAccountsByType(item, GLAccountType.INCOME)),

    expenses = glAccountsData.filter(item => filterGLAccountsByType(item, GLAccountType.EXPENSE)),

    liabilities = glAccountsData.filter(item => filterGLAccountsByType(item, GLAccountType.LIABILITY))

    return (
      <div>
        { this.renderAssets(assets) }
        <hr />

        { this.renderIncome(incomes) }
        <hr />

        { this.renderExpenses(expenses) }
        <hr />

        { this.renderLiabilities(liabilities) }
        <hr />
      </div>
    )
  }

  renderButtonUpdate = () => (
    <Button onClick={() => browserHistory.push('/loanaccounting/create')}
      className="w-100" bsStyle="info">
      <FontAwesome name='pencil' /> Edit
    </Button>
  )

  renderContent = () => {

    const { running, error, success, closeStatuses, isUpdate } = this.state

    return (
    <div className="simple-form max-width-1000 mx-auto mb-20">

      <div className="flex-row">

        <h3 className="text-center">
          Loan integration with Accounting &nbsp;
          <small>
            <a href={ mifosLink } target="_blank">{ this.getTooltipHelp() }</a>
          </small>
        </h3>

         { !isUpdate && this.renderButtonUpdate() }
      </div>
      <hr />

      { this.renderAccountingType() }
      <hr />

      { this.renderSections() }

      <CloseableProcessesStatus
        error={ error }
        running={ running }
        success={ success }
        close={ closeStatuses }
        handleClose={() => this.setState({ closeStatuses: true })}
      />

      { isUpdate && this.renderButtons() }
    </div>
  )}

  render() {

    const dataBreadCrumbs = [{ url: '/accounting', title: 'Accounting' }]

    return (
      <div>
        <CustomBreadCrumb activeText='Loan accounting' data={ dataBreadCrumbs } />
        { this.renderContent() }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)
  return { glAccounts }
}

const mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoanAccountingForm)



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanAccounting/Form.js